"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ProductsMultipleViewReducer = undefined;

var _apiCategoryProducts_post = require("../actions/esdb/apiCategoryProducts_post");

var _apiElasticsearch_search_post = require("../actions/esdb/apiElasticsearch_search_post");

var _apiProductsFeatured = require("../actions/esdb/apiProductsFeatured");

var _apiManufacturerProductOverview_post = require("../actions/esdb/apiManufacturerProductOverview_post");

var _apiProductPromotionOverview_post = require("../actions/esdb/apiProductPromotionOverview_post");

var _apiProductsNewest_post = require("../actions/esdb/apiProductsNewest_post");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProductsMultipleViewReducer = exports.ProductsMultipleViewReducer = function ProductsMultipleViewReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case _apiProductsFeatured.API_PRODUCTS_FEATURED_REQUEST:
		case _apiCategoryProducts_post.API_CATEGORY_PRODUCTS_POST_REQUEST:
		case _apiManufacturerProductOverview_post.API_MANUFACTURER_PRODUCT_OVERVIEW_POST_REQUEST:
		case _apiProductPromotionOverview_post.API_PRODUCT_PROMOTION_OVERVIEW_POST_REQUEST:
		case _apiProductsNewest_post.API_PRODUCTS_NEWEST_POST_REQUEST:
		case _apiElasticsearch_search_post.API_ELASTICSEARCH_SEARCH_POST_REQUEST:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.options.VIEW, action.payload));

		case _apiProductsFeatured.API_PRODUCTS_FEATURED_SUCCESS:
		case _apiCategoryProducts_post.API_CATEGORY_PRODUCTS_POST_SUCCESS:
		case _apiManufacturerProductOverview_post.API_MANUFACTURER_PRODUCT_OVERVIEW_POST_SUCCESS:
		case _apiProductPromotionOverview_post.API_PRODUCT_PROMOTION_OVERVIEW_POST_SUCCESS:
		case _apiProductsNewest_post.API_PRODUCTS_NEWEST_POST_SUCCESS:
		case _apiElasticsearch_search_post.API_ELASTICSEARCH_SEARCH_POST_SUCCESS:

			return Object.assign({}, state, _defineProperty({}, action.payload.data.VIEW, _lodash2.default.merge({}, action.payload, {
				data: {
					PRODUCTS: action.payload.data.PRODUCTS.map(function (p) {
						return p.SKU;
					})
				}
			})));

		default:
			return state;
	}
};